module.exports = __webpack_public_path__ + "static/media/noun_Flight_white_3406429.d57a7e31.svg";